<template>
  <v-card color="white" class="card-border">
    <v-system-bar height="45" color="itoviGrayLight">
      <h2 class="card-header-text">Your Plan</h2>
      <v-spacer />
    </v-system-bar>

    <ManagePlanDialog v-if="!!planDetails" :plan="planDetails" />
    <ManageReferenceBooksDialog v-if="!!addOns" />
    <ViewPlanDetailsDialog v-if="!!planDetails" v-model="showPlanDetailsDialog" :plan="planDetails" />
    <PurchaseWarrantyDialog v-model="showExtendedWarrantyDialog"/>

    <div v-if="!(!!planDetails && !!nextPayment && !!addOns)" class="pa-4">
      <v-progress-linear :indeterminate="true" />
    </div>
    <div class="card-body" v-if="!!planDetails && !!nextPayment && !!addOns">

      <!-- Plan name               -->
      <v-layout row wrap>
        <v-flex xs7>
          <v-layout column class="ma-0">
            <span class="txt-bold mb-1"><span v-if="planDetails.status === 'paused'">(Paused)</span> {{ planDetails.name }}</span>
            <div v-if="planDetails.monthly !== null && planDetails.monthly > 0">
              ${{ planDetails.monthly }} / mo
            </div>
            <span v-if="planDetails.status === 'cancelled'">(Cancelled)</span>
          </v-layout>
        </v-flex>
        <v-flex xs5>
          <v-layout>
            <v-spacer />
            <v-btn small flat color="accent"
                   v-if="planDetails.upgradeable_plans.length > 0"
                   @click="openManagePlanDialog()" class="txt-bold mt-0">Manage
            </v-btn>
            <v-btn small flat color="accent"
                   v-if="planDetails.upgradeable_plans === false || planDetails.upgradeable_plans.length === 0"
                   @click="showPlanDetailsDialog=true" class="txt-bold mt-0">View
            </v-btn>
          </v-layout>
        </v-flex>
        <v-flex v-if="planDetails && planDetails.name === 'Hold'" xs12 >
          <v-flex class="itoviHold--text"><v-layout style="font-weight: bold"><img src="../../../assets/hold_icon.svg" class="mr-1 mb-1" height="22" width="22"/>Hold</v-layout></v-flex>
          <div class="xs12" style="font-size: 12px">Your account is on hold maintaining your data</div>
        </v-flex>

        <v-flex v-if="planDetails && planDetails.status === 'paused'" xs12 >
          <v-flex class="itoviPaused--text"><v-layout style="font-weight: bold"><img src="../../../assets/paused_icon.svg" class="mr-1 mb-1" height="22" width="22"/>Paused</v-layout></v-flex>
          <div class="xs12" style="font-size: 12px">Your account is paused due to failed payments</div>
        </v-flex>
      </v-layout>

      <v-layout v-if="planDetails && planDetails.pending_status" align-center row wrap>
        <div>
          This plan is scheduled to be {{ planDetails.pending_status.action_code === 'cancel' ? 'cancelled' : (planDetails.pending_status.action_code === 'hold' ? 'placed on hold' : 'changed') }} on {{ planDetails.pending_status.run_date }}.
        </div>
      </v-layout>


      <v-divider class="mt-4 mb-3" />

      <!-- Add-ons               -->
      <v-layout row wrap>
        <span class="txt-bold">Reference Books</span>
        <v-spacer />
        <v-btn small flat color="accent" class="txt-bold mt-0" @click="$store.commit('setShowReferenceBooksDialog', true)">Manage</v-btn>
      </v-layout>

      <template v-for="(item, index) in addOns.applied.filter(addOn => addOn.name !== 'Insurance' && addOn.name !== 'Extended Warranty')">
        <v-layout :key="index" align-center row wrap>
          <span>{{ item.name }}</span>
          <v-spacer />
          <span v-if="item.is_yearly > 0" class="pr-3">${{ item.yearly }} / year</span>
          <span v-if="!item.is_yearly > 0 && item.monthly > 0" class="pr-3">${{ item.monthly }} / mo</span>
        </v-layout>
      </template>

      <v-divider class="mt-4 mb-3" />

      <!-- Extended Warranty -->
      <v-layout>
        <span class="txt-bold">Extended Warranty</span>
        <v-spacer />
        <v-btn small flat color="accent" class="txt-bold mt-0" @click="showExtendedWarrantyDialog=true">{{ hasWarranty() ? "View" : "Purchase" }}</v-btn>
      </v-layout>

      <v-divider class="mt-4 mb-3" />

      <!-- Monthly payment               -->
      <v-layout align-center row wrap>
        <span class="txt-bold">Monthly Payment</span>
        <v-spacer />
        <span class="txt-bold">${{ nextPayment.amount }}</span>
        <span class="txt-bold"
              style="font-size: 7pt;">&nbsp;/ mo</span>
      </v-layout>

    </div>
  </v-card>

</template>

<script>
  import api from "../../../services/api_endpoints";
  import store from '../../../store'
  import ManagePlanDialog from './ManagePlanDialog'
  import ManageReferenceBooksDialog from './ManageReferenceBooksDialog'
  import ViewPlanDetailsDialog from './ViewPlanDetailsDialog'
  import subscribeToStore from "@/mixins/subscribeToStore";
  import PurchaseWarrantyDialog from "@/components/dashboard/yourPlanCard/PurchaseWarrantyDialog";
  import ccHelper from "@/mixins/ccHelper";

  export default {
    components: {
      ManagePlanDialog,
      ViewPlanDetailsDialog,
      ManageReferenceBooksDialog,
      PurchaseWarrantyDialog
    },
    mixins: [subscribeToStore, ccHelper],
    data: ()=> ({
      planDetails: store.state.planDetails,
      nextPayment: store.state.nextPayment,
      ccInfo: store.state.ccInfo,
      addOns: store.state.addOns,
      showReferenceBooksDialog: store.state.showReferenceBooksDialog,
      showPlanDetailsDialog: false,
      showExtendedWarrantyDialog: false
    }),
    props: {
      onLoaded: Function,
    },
     async created(){
       await this.fetchData();
      if (this.$route.query.hasOwnProperty('addons')) {
        this.showManageAddOnsDialog = true;
      }
    },
    updated() {
      this.checkUrlQueryStatus();
    },
    mounted() {
      this.subscribeToStore(['planDetails', 'nextPayment', 'addOns', 'ccInfo', 'showReferenceBooksDialog']);
      this.checkUrlQueryStatus();
    },
    methods: {
      openManagePlanDialog() {
        this.$store.commit('setShowManagePlanDialog',true)
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      async fetchData() {
        const planDetails = await api.getPlanDetails()
        const addOns = await api.getPlanAddOns()
        const nextPayment = await api.getNextPayment()
        this.$store.commit('setPlanDetails', planDetails);
        this.$store.commit('setAddOns', addOns);
        this.$store.commit('setNextPayment', nextPayment);
        if (this.isFunction(this.onLoaded)) this.onLoaded()
      },
      checkUrlQueryStatus() {
        if (!this.$store.state.initialUrlParameters.hasOwnProperty("status")) return;
        const status = this.$store.state.initialUrlParameters.status;

        if (status === "referencebooks") return this.$store.commit('setShowReferenceBooksDialog', true);

        else if (this.planDetails && status === "reactivate") {
          if (this.ccInfo && (this.isExpiringSoon() || this.isExpired())) {
            this.$store.commit("setShowUpdateCcDialog", true);
          }
          else if ((this.planDetails.status === "paused") || (this.planDetails.status === "active" && this.planDetails.name === "Hold")) {
            this.$store.commit("setShowManagePlanDialog", true);
          }
        }

        const initialUrlParameters = this.$store.state.initialUrlParameters;
        delete initialUrlParameters.status;
        this.$store.commit("setInitialUrlParameters", initialUrlParameters);
      },
      hasWarranty() {
        return !!this.addOns['applied'].filter((addOn) => addOn.name === "Extended Warranty" || addOn.name === "Insurance").length;
      }
    },
  }
</script>
